const STORAGE_KEY = 'lastSearches';
const MAX_SEARCHES = 5;
/**
 * Add a search term to the last searches list
 * @param searchTerm - The search term to add
 */
export function addSearch(searchTerm) {
    if (!searchTerm || searchTerm.trim().length === 0) {
        return;
    }
    try {
        const cleanedSearchTerm = searchTerm.trim().replace(/\s+/g, ' ');
        const existingSearches = getLastSearches();
        const filteredSearches = existingSearches.filter((search) => search.toLowerCase() !== cleanedSearchTerm.toLowerCase());
        const updatedSearches = [cleanedSearchTerm, ...filteredSearches];
        const trimmedSearches = updatedSearches.slice(0, MAX_SEARCHES);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedSearches));
    }
    catch (error) {
        console.error('Error saving search to localStorage:', error);
    }
}
/**
 * Get the last 5 searches from local storage
 * @returns Array of search terms (most recent first)
 */
export function getLastSearches() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
        return [];
    }
    try {
        const searches = JSON.parse(stored);
        if (!Array.isArray(searches)) {
            localStorage.removeItem(STORAGE_KEY);
            return [];
        }
        return searches
            .filter((search) => typeof search === 'string' && search.trim().length > 0)
            .map((search) => search.trim().replace(/\s+/g, ' '))
            .filter((search) => search.length > 0)
            .slice(0, MAX_SEARCHES);
    }
    catch (error) {
        console.error('Error reading searches from localStorage:', error);
        localStorage.removeItem(STORAGE_KEY);
        return [];
    }
}
/** Escape HTML for both content and attributes */
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/**
 * Trigger a search by filling the input and executing the search
 */
function triggerSearch(searchTerm) {
    const input = document.querySelector('[data-search-input]');
    const button = document.querySelector('[data-search-button]');
    if (!input || !button) {
        return;
    }
    input.value = searchTerm;
    button.click();
}
/**
 * Attach click handlers to popular search suggestions
 */
export function attachSuggestionsHandlers() {
    const suggestionsList = document.querySelector('[data-search-suggestions-list]');
    if (!suggestionsList) {
        return;
    }
    if (suggestionsList.dataset.listenerAttached === 'true') {
        return;
    }
    suggestionsList.addEventListener('click', (event) => {
        const target = event.target;
        const button = target.closest('[data-search-term]');
        if (button?.dataset.searchTerm) {
            triggerSearch(button.dataset.searchTerm);
        }
    });
    suggestionsList.dataset.listenerAttached = 'true';
}
/**
 * Display the last searches in the recent searches container
 * and attach click handlers to trigger searches
 */
export function displayLastSearches() {
    const recentSearchesContainer = document.querySelector('[data-recent-searches]');
    const recentSearchesList = document.querySelector('[data-recent-searches-list]');
    const recentSearches = getLastSearches();
    if (!recentSearchesList || recentSearches.length === 0) {
        return;
    }
    // Generate HTML for recent searches
    recentSearchesList.innerHTML = recentSearches
        .map((search) => `
    <li><button type="button" class="flex link py-1 font-bold octobre:font-medium text-left cursor-pointer" data-search-term="${escapeHtml(search)}"><span class="link-underline-effect">${escapeHtml(search)}</span></button></li>`)
        .join('');
    if (recentSearchesList.dataset.listenerAttached === 'true') {
        return;
    }
    // Attach click handler to recent searches list
    recentSearchesList.addEventListener('click', (event) => {
        const target = event.target;
        const button = target.closest('[data-search-term]');
        if (button?.dataset.searchTerm) {
            triggerSearch(button.dataset.searchTerm);
        }
    });
    recentSearchesList.dataset.listenerAttached = 'true';
    // Show the container
    recentSearchesContainer?.classList.remove('hidden');
}
